import _ from 'topmeteo/utils/i18n';

const Label = _('Name');

const NameInput = () => (
    <label htmlFor="name-input">
        <span>{Label}</span>
        <input id="name-input" type="text" name="name" maxLength={100} />
    </label>
);

export default NameInput;
